<!-- modal-confirmation-sms.component.html -->
<app-page-header title="Recuperar senha" [headerFlexWrap]="false">
  <div class="container-button-close">
    <button type="button" class="btn-close" aria-label="Close" (click)="dialogRef.close()"></button>
  </div>
</app-page-header>
<mat-dialog-content>
  <div class="alert alert-info">Você receberá no e-mail informado os passos para recuperar sua senha.</div>
  <div class="mb-3 mt-3">
    <label for="email" class="form-label">Informe o email da conta</label>
    <input type="email" class="form-control" id="email" [formControl]="emailCtrl" />
    @if (emailCtrl.invalid && emailCtrl.touched) {
      <div class="invalid-feedback">O email é obrigatório e deve ser válido.</div>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <app-button type="submit" [disabled]="!emailCtrl.valid || loading" (btnClick)="send()"> Recuperar senha </app-button>
</mat-dialog-actions>
